module.exports = __webpack_public_path__ + "static/CustomerThree-105be8363e3fc4241b5208ca2f1329a4.jpeg";